export const SUB_COVER_PLATFORM_TYPE = 5;

export const subCoverSize = {
  id: 50001,
  key: "sub-cover",
  name: "公众号次图",
  fileName: "公众号次图",
  width: 200,
  height: 200,
  previewScale: 1,
  backgroundPosition: "left center",
  text: {
    oneCharSize: 136,
    multiCharSize: 70,
    lineHeight: 1,
    letterSpacing: 0,
    rowGap: 0,
  },
};

export const subCoverExportSize = {
  ...subCoverSize,
  width: 500,
  height: 500,
  previewScale: 1,
  text: {
    oneCharSize: 340,
    multiCharSize: 175,
    lineHeight: 1,
    letterSpacing: 0,
    rowGap: 0,
  },
};

export const defaultSubCoverTextStyle = {
  id: 0,
  styles: [
    {
      fontColor: "#fff",
      fontFamily: "阿里巴巴普惠体 Heavy",
      fontWeight: 700,
    },
  ],
};

export const subCoverMap = {
  tagId: 0,
  backgroundId: 0,
  elementId: 0,
  textStyleId: 0,
  elementTypeId: 0,
  bgParameter: {
    src: "",
    tagBgColor: "#F34848",
    textShadowColor: "#781f1f",
  },
  elementImg: "",
  isAiElement: false,
  textValue: [""],
  textStyle: JSON.parse(JSON.stringify(defaultSubCoverTextStyle.styles)),
};
